<template>
	<div class="home">
		<van-nav-bar
		  	title="分类"
			left-arrow
		  	@click-left="$router.push('')">
		</van-nav-bar>
		<van-checkbox-group v-model="perferResult">
			  	<van-cell-group>
		    		<van-cell
		      		v-for="(perfer, index) in perfers"
		      		clickable
		      		:key="index"
		      		:title="perfer.name"
		      		@click="toggle(index)">
				      	<van-checkbox
					        :name="perfer.id"
					        ref="checkboxes"
					        slot="right-icon">
						  	<img
						  		style="width: 20px;height: 20px"
						    	slot="icon"
						    	slot-scope="props"
						    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
						  	>
					    </van-checkbox>
			    	</van-cell>
			  	</van-cell-group>
			</van-checkbox-group>
		<div class="shopBottom">
			<van-button class="cancelBtn"  size="normal" round>取消</van-button>
			<van-button class="certainBtn"  size="normal" round >确定</van-button>
		</div>
	</div>
</template>

<script>
export default {
	data () {
      	return {
      		perfers:[],
			perferResult:[],
      	}
	},
	mounted:function(){
    	this.getPerfers();
	},
	methods:{
		getPerfers(){
			// 获取
			this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/tags/'+sessionStorage.actShopId+'/index/0/perfer',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.perfers=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:'登录失效',
        		});
            });
		},
		toggle(index) {
  			console.log(index)
  			this.$refs.checkboxes[index].toggle();

	    },
	}
}
</script>

<style scoped>
	.home{
		width: 100%;
		height: 100vh;
	}
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	/* .van-field input{text-align: right;} */
	.home{
		width: 100%;
		height: 100vh;
	}
	.shopBottom{
		position: absolute;
		bottom: 0;
		height: 60px;
		background: #fff;
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.cancelBtn{
		width: 30%;
		top: 10%;
		left: 5%;
		background: #DFDEDE;
		font-weight: bold;
		font-size: 16px;
	}
	.certainBtn{
		width: 30%;
		top: 10%;
		right: 5%;
		background:linear-gradient(90deg,#FFC914,#FFB20D);
		font-weight: bold;
		font-size: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/Shop/setCategory.vue